// TYPES
import { ReducerActionRotaSP } from 'store/modules/types';
import {
	ConsultaReimpressaoFic,
	RequestConsultaReimpressaoFic,
	Types,
} from './types';

export function consultaReimpressaoFicRequest(
	token: string,
	payload: RequestConsultaReimpressaoFic,
): ReducerActionRotaSP {
	return {
		type: Types.CONSULTA_REIMPRESSAO_FIC_REQUEST,
		token,
		payload,
	};
}
export function consultaReimpressaoFicSuccess(
	payload: ConsultaReimpressaoFic,
): ReducerActionRotaSP {
	return {
		type: Types.CONSULTA_REIMPRESSAO_FIC_SUCCESS,
		payload,
	};
}
export function consultaReimpressaoFicFailure(): ReducerActionRotaSP {
	return {
		type: Types.CONSULTA_REIMPRESSAO_FIC_FAILURE,
		payload: null,
	};
}
export function consultaReimpressaoFicClear(): ReducerActionRotaSP {
	return {
		type: Types.CONSULTA_REIMPRESSAO_FIC_CLEAR,
		payload: null,
	};
}
